<template>
    <div>
        <div v-if="!isLoading">
            <div class="list-group">
                <a
                    href="JavaScript:void(0);"
                    class="list-group-item list-group-item-action"
                    v-for="(option, index) in repairOptionsList"
                    :key="index"
                    @click="optionSelected(option)">
                    <div class="row">
                        <div class="col-sm-3 text-center">
                            <i
                                v-bind:class="option.repairOptionWebDisplayIcon"
                                style="font-size: 92px;">
                            </i>
                        </div>
                        <div class="col">
                            {{option.repairOptionWebDisplayDescription}}
                        </div>
                    </div>
                </a>
            </div>
        </div>
        <div v-else>
            Loading...
        </div>
    </div>
</template>

<script>
export default {
  name: 'repairOptionsList',
  computed: {
    isLoading () {
      return this.$store.state.repairoptions.loading
    },
    repairOptionsList () {
      return this.$store.state.repairoptions.repairOptionsList
    }
  },
  data: () => {
    return {

    }
  },
  methods: {
    optionSelected (option) {
      this.$emit('selected',
        { ...option }
      )
    }
  }
}
</script>
